import React from 'react';
import { useLocation } from 'react-router-dom';
import { getModuleByRoute } from '../constants/moduleCatalog';
import { isModuleEnabled } from '../helpers/modules';

/**
 * ModuleRouteGuard — חוסם גישה ל-route של מודול פרימיום כבוי (אכיפה צד-לקוח).
 * עוטף את ה-Outlet של ReportPage/ProfitabilityPage ואת מסך שליחת ההודעות.
 * מודול בסיס / route ללא התאמה בקטלוג → מציג את התוכן כרגיל.
 *
 * הערה: זו הגנה ויזואלית בלבד; האכיפה האמיתית היא ב-backend (ModuleEnforcementMiddleware).
 */
const ModuleRouteGuard = ({ children }) => {
  const { pathname } = useLocation();
  const mod = getModuleByRoute(pathname);

  if (mod && !mod.isBasic && !isModuleEnabled(mod.code)) {
    return (
      <div style={{ padding: '48px 20px', textAlign: 'center' }}>
        <i className="ri-lock-2-line" style={{ fontSize: 44, color: '#9ca3af' }} />
        <h5 style={{ marginTop: 16, color: '#374151' }}>המודול אינו פעיל עבור החברה</h5>
        <p className="text-muted" style={{ margin: 0 }}>
          להפעלת המודול פנו למנהל המערכת.
        </p>
      </div>
    );
  }

  return children;
};

export default ModuleRouteGuard;
